import {EventEmitter, Injectable} from '@angular/core';
import {ConsultCriteria} from '../../../model/consult-criteria';
import {StorageService} from '../../storage/storage.service';
import {BehaviorSubject, Subject} from 'rxjs';

/**
 * Service that handleChangeOfSelectFold search results using criterias
 */
@Injectable()
export class ConsultCriteriaService {

  /**
   * list of criterias used for display
   */
  public exposedCriterias: BehaviorSubject<ConsultCriteria[]>;
  public activeTabEvent: EventEmitter<number>;
  public selectFoldEvent: EventEmitter<number>;
  /**
   * The folds list that could be subscribed
   */
  public exposeJsonFolds: Subject<any>;
  public foldListReady: Subject<boolean>;

  /**
   * @param {StorageService} storageService - only there to store and put in storage Criterias
   */
  constructor(private storageService: StorageService) {
    this.exposeJsonFolds = new Subject();
    this.foldListReady = new Subject();
    this.exposedCriterias = new BehaviorSubject<ConsultCriteria[]>([]);
    this.activeTabEvent = new EventEmitter<number>();
    this.selectFoldEvent = new EventEmitter<number>();
    this.init();
  }

  /**
   * Handle retrieving info from storage if it's not empty (usefull if Refresh...)
   */
  private init(): void {
    const criteriasFromStorage = this.storageService.getConsultCriteriasFromStorage();
    if (criteriasFromStorage) {
      this.exposedCriterias.next(criteriasFromStorage);
    }
  }

  /**
   * build criterias for the service and store them
   * @param toBuild - list of Criterias gave by the back-office
   */
  public buildCriterias(toBuild: any): void {
    const criterias: ConsultCriteria[] = [];

    for (let i = 0; i < toBuild.length; i++) {
      criterias.push(
        new ConsultCriteria(
          toBuild[i].bDisplay,
          toBuild[i].bRestrictToSuggestedValues,
          toBuild[i].sCategory,
          toBuild[i].sHelpI18n,
          toBuild[i].sLibI18n,
          toBuild[i].sNameI18n,
          toBuild[i].sNameId,
          toBuild[i].sStorageName,
          toBuild[i].sStorageType,
          toBuild[i].sTypeData,
        )
      );
    }
    this.storageService.removeConsultCriteriasFromStorage();
    this.storageService.addConsultCriteriasInStorage(criterias);
    this.exposedCriterias.next(criterias);
  }

  /**
   * expose the list of folds according to the param
   * @param result - the list of fold to expose (should be json)
   */
  public fillConsultWithResults(result) {
    this.exposeJsonFolds.next(result);
  }
  public setActiveTab(index: number) {
    this.activeTabEvent.next(index);
  }
  public selectFold(serialSent: number) {
    this.selectFoldEvent.next(serialSent);
  }
}
